import navbarData from './navbar.json';
import heroData from './hero.json';
import aboutData from './about.json';
import servicesData from './services.json';
import portfolioData from './portfolio.json';
import contactData from './contact.json';
import footerData from './footer.json';

export const data = {
    navbar: navbarData,
    hero: heroData,
    about: aboutData,
    services: servicesData,
    portfolio: portfolioData,
    contact: contactData,
    footer: footerData
};

export default data;
